// Setup the namespace for this logic
var readOnlyExitActionHelper = readOnlyExitActionHelper || {};

readOnlyExitActionHelper.initialize = function() {
	ap.consoleInfo("readOnlyExitActionHelper initialize!");

	// If this page.type is of "dataEntry" or "roster", and page.readOnly is true, and the next menu item's isAvailable 
	//   state is false, then hide the normal page action(s), and insert an Exit button in its/their place.
	if (page==null)
		return;
	
	if (page.type!="dataEntry" && page.type!="roster")
		return;
	
	if (page.readOnly==false)
		return;
	
	if (menu==null)
		return;
	
	var nextMenuEntry = menu.getNextEntry();
	if (nextMenuEntry==null || nextMenuEntry.isAvailable==true)
		return;
	
	// The conditions are ripe to replace the actions with [ Exit ].  Find the existing actions <P> and hide it
	var buttonList = $("div.btn-group input");
	if (buttonList==null || buttonList.length<1)
		return;
	
	var actionsP = buttonList[0];
	if (actionsP==null)
		return;
	
	actionsP.style.display = "none";
	
	// Now create the replacement Exit button, and add it where the other actions were
	var exitButton = document.createElement("input");
	exitButton.id = "exitButton";
	exitButton.type = "button";
	exitButton.onclick = function(){window.location="DisplayWorkInProgress?WorkListType=WorkItemsView";};
	exitButton.value = "Exit";
	exitButton.name = "exitButton";
	exitButton.className = "btn btn-primary";

	actionsP.parentNode.appendChild(exitButton);
};